export function createSerializationStats() {
    return {
        cssText: {
            count: 0,
            max: 0,
            sum: 0,
        },
    };
}
export function updateCssTextSerializationStats(stats, value) {
    stats.cssText.count += 1;
    stats.cssText.max = Math.max(stats.cssText.max, value);
    stats.cssText.sum += value;
}
export function aggregateSerializationStats(aggregateStats, stats) {
    aggregateStats.cssText.count += stats.cssText.count;
    aggregateStats.cssText.max = Math.max(aggregateStats.cssText.max, stats.cssText.max);
    aggregateStats.cssText.sum += stats.cssText.sum;
}
//# sourceMappingURL=serializationStats.js.map